import React, { Component } from 'react'

import { Link, Redirect } from 'react-router-dom'
import { Grid, Button } from 'react-bootstrap'

import Loading from '../../components/shared/Loading'

import { CompleteProfileForm } from './CompleteProfileForm'
import { Message } from './Message'

import { Banner } from './Banner'
import { updateProfile } from '../../../lib/authentication'

import { createIdentityMap } from '../utils'

import routes from '../../constants/routes'

import './auth.scss'

const Stages = createIdentityMap(
  'UNAVAILABLE',
  'ENTERING_PROFILE',
  'SUBMITTING_PROFILE',
  'VALID_PROFILE',
  'INVALID_PROFILE'
)

export default class CompleteProfile extends Component {
  constructor(props) {
    super(props)

    this.state = {
      firstName: '',
      lastName: '',
      title: '',
      phone: '',
      phoneExt: '',
      error: { errorSummary: '', errorItems: [] },
      stage: Stages.ENTERING_PROFILE,
    }
  }

  componentDidMount() {
    if (!this.props.isAuthenticated) {
      this.setStage(Stages.UNAVAILABLE);
    } else {
      this.handleGetUserData()
    }
  }

  setError(errorSummary, ...errorItems) {
    this.setState({ error: { errorSummary, errorItems } })
  }

  setStage(stage) {
    this.setState({ stage })
  }

  isOnStage(...stages) {
    return stages.includes(this.state.stage)
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value
    })
  }

  handleGetUserData() {
    const { firstName, lastName, title, phone, phoneExt } = this.props
    this.setState({ firstName, lastName, title, phone, phoneExt })
  }

  //TODO: If password reset was successful, we should already be logged in
  // So display a link to /submissions in the success message?
  handleSubmitForm = async (event) => {
    event.preventDefault()

    this.setError()
    this.setStage(Stages.SUBMITTING_PROFILE)

    const { success, error } = await updateProfile(this.state.firstName, this.state.lastName, this.state.phone, this.state.phoneExt, this.state.title)

    if (!success && error) {
      const { errorSummary = '', errorItems = [] } = error
      this.setError(errorSummary, ...errorItems)
      this.setStage(Stages.INVALID_PROFILE)
      return
    }

    if (success && !error) {
      this.setStage(Stages.VALID_PROFILE)
      this.props.setAuth()
      return
    }

    this.setError('Unknown Error occurred', 'Please try again')
    this.setStage(Stages.ENTERING_PROFILE)
  }

  validateForm = () => {
    const { firstName, lastName, title, phone, phoneExt } = this.state
    const isValidForRequiredFields = (firstName.length && lastName.length && phone.length)

    const isValidPhoneExt = phoneExt.length ? /^[0-9]+$/.test(phoneExt) : true

    return isValidForRequiredFields && isValidPhoneExt
  }

  renderForm() {
    const { firstName, lastName, title, phone, phoneExt } = this.state
    return (
      <CompleteProfileForm
        onSubmit={this.handleSubmitForm}
        onChange={this.handleChange}
        validateForm={this.validateForm}
        firstName={firstName}
        lastName={lastName}
        title={title}
        phone={phone}
        phoneExt={phoneExt}
      >
        {this.isOnStage(Stages.INVALID_PROFILE) && this.renderErrors()}
      </CompleteProfileForm>
    )
  }

  renderErrors() {
    const { error: { errorSummary = 'Unknown Error Ocurred', errorItems = [] } = {} } = this.state
    return (
      <Message title={errorSummary} type="danger">
        {errorItems.map(errorItem => (<p key={btoa(errorItem)}>{errorItem}</p>))}
      </Message>
    )
  }

  renderValidMessage() {
    return (
      <div>
        <h1>You&apos;re all set!</h1>
        <div className="allSet">
          <i className="fa fa-check-circle fa-3" aria-hidden="true" />
          <p> View your homepage to create and edit submissions. </p>
          <Link to="/" className="btn btn-link"> View Homepage</Link>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="AuthContainer vertical">
        <Banner username={this.props.username} brokerName={this.props.brokerName} />
        <Grid className="currentStep">
          <div className="AuthContainerForm">
            {this.isOnStage(Stages.UNAVAILABLE) && <Redirect to={routes.LOGIN} />}
            {this.isOnStage(Stages.SUBMITTING_PROFILE) && <Loading classes="loading" />}
            {this.isOnStage(Stages.ENTERING_PROFILE, Stages.INVALID_PROFILE) && this.renderForm()}
            {this.isOnStage(Stages.VALID_PROFILE) && this.renderValidMessage()}
          </div>
        </Grid>
      </div>
    )
  }
}

